<template>
  <v-navigation-drawer
    v-model="visible"
    left
    hide-overlay
    temporary
    fixed
    touchless
    class="nav-drawer"
    :style="$voicer.getThemeConfigProperty('components.aside.style')"
    v-bind="$voicer.getThemeConfigProperty('components.aside.props')"
  >
    <v-divider />

    <v-list class="mb-2">
      <v-list-tile @click="handleClickUniverseMenu()">
        <v-icon class="primary--text font-weight-bold mr-2 pl-2">
          mdi-home
        </v-icon>
        <v-list-tile-title class="primary--text font-weight-bold subheading">
          {{ $t('glob_home') }}
        </v-list-tile-title>
      </v-list-tile>
      <v-list-tile v-if="navigationItems.length">
        <v-list-tile-sub-title class="text-alternate subtitle px-2">
          {{ $t('glob_home_all_universes') }}
        </v-list-tile-sub-title>
      </v-list-tile>
      <v-list-tile
        v-for="navigation in navigationItems"
        :key="navigation.tagId"
        no-action
        @click="handleClickUniverseMenu(navigation.tagId)"
      >
        <v-list-tile-title
          v-if="navigationItems.length"
          class="px-2 collection_title"
          v-text="
            navigation.i18n?.[$i18n.locale]?.title ||
            $t('glob_default_universe_name')
          "
        />
      </v-list-tile>
      <div v-if="navigationSubItems.length">
        <v-divider class="mb-2" />
        <v-list-tile>
          <v-list-tile-sub-title class="text-alternate subtitle px-2">
            {{ $t('glob_specific_pages') }}
          </v-list-tile-sub-title>
        </v-list-tile>
        <v-list-tile
          v-for="navigation in navigationSubItems"
          :key="navigation.tagId"
          no-action
          @click="handleClickSubMenu(navigation)"
        >
          <v-list-tile-title class="px-2">
            <v-icon left small>{{ navigation.icon }}</v-icon>
            {{ navigation.title || $t('glob_default_universe_name') }}
          </v-list-tile-title>
        </v-list-tile>
      </div>
    </v-list>
  </v-navigation-drawer>
</template>

<script>
import utilsMixin from '~/mixins/utils'

export default {
  mixins: [utilsMixin],
  props: {
    navigationItems: {
      type: Array,
      default: () => [],
    },
    navigationSubItems: {
      type: Array,
      default: () => [],
    },
    value: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    visible: {
      get() {
        return this.value
      },
      set(state) {
        this.$emit('input', state)
      },
    },
    navs() {
      return this.navigationItems.map((nav) => {
        if (nav.items && Array.isArray(nav.items)) {
          nav.items = nav.items.map((snav) => {
            return {
              ...snav,
              title:
                typeof snav.title === 'function'
                  ? snav.title(this)
                  : snav.title,
            }
          })
        }

        return {
          ...nav,
          title: typeof nav.title === 'function' ? nav.title(this) : nav.title,
        }
      })
    },
  },
  methods: {
    handleClickUniverseMenu(item) {
      this.$router.push(item ? `/universe/${item}` : '/')
    },
    handleClickSubMenu(item) {
      if (!item.disableAutoClose) {
        this.visible = false
      }
      if (item.noAction) {
        return
      }

      if (typeof item.onClick === 'function') {
        item.onClick(this)
      }

      // default type is link
      if (!item.type || item.type === 'link') {
        this.$router.push({
          path: item.value,
        })
      }

      // external link
      if (item.type === 'external-link') {
        window.open(item.value, '_blank')
      }
    },
  },
}
</script>

<style scoped lang="scss">
.nav-drawer {
  padding-bottom: 100px; /* pour éviter que le contenu soit caché derrière le player */
  .title {
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
  }
  .subtitle {
    color: darkgray;
  }
  .collection_title {
    font-size: 16px;
  }
}
</style>
